import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { dayjs } from '../../Dayjs/dayjs-utils';

interface ClockProps {
    clockColor?: string;
    clockSize: string | undefined | string[];
    tz?: string;
}

export default function Clock({ clockColor = 'white', clockSize, tz }: Readonly<ClockProps>) {
    const [currentTime, setCurrentTime] = useState<string>('');
    const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    useEffect(() => {
        const intervalId = setInterval(() => {
            const now = dayjs().tz(tz || localTz);
            const formattedTime = now.format('HH:mm:ss');
            setCurrentTime(formattedTime);
        }, 1000);

        // Clear the interval on component unmount
        return () => clearInterval(intervalId);
    }, [localTz, tz]);

    return (
        <Stack>
            <Typography sx={{ color: clockColor, fontSize: clockSize }} variant="h6">
                {currentTime}
            </Typography>

            <Typography sx={{ color: clockColor, fontSize: clockSize }}>{tz}</Typography>
        </Stack>
    );
}
